/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      karine
 * @date        23/09/2021 15:35
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (https://www.iris-interactive.fr)
 *
 */

import ObfuscationAction from "../actions/obfuscation.action"

export default class ObfuscationService {
    constructor() {
        if ($("[data-obf]").length > 0) {
            ObfuscationAction.initObfuscation()
        }
    }
}
